import React from 'react';
import NoticeList from '../components/setting/NoticeList';

const NoticePage: React.FC = () => {
  return (
    <div className="main-container">
      <NoticeList />
    </div>
  );
};

export default NoticePage;
